import { Box, Typography } from '@mui/material'

interface LogoProps {
  variant?: 'sidebar' | 'header' | 'compact' | 'topbar' | 'login'
  showText?: boolean
}

export default function Logo({ variant = 'sidebar', showText = true }: LogoProps) {
  const isLogin = variant === 'login'
  const onDark = variant === 'topbar'
  const title = isLogin ? 'Tuan Loc Commodities' : 'ERP CTRM'
  const subtitle = isLogin ? 'ERP CTRM' : 'Tuan Loc Commodities'
  const logoIcon = (
    <Box
      component="img"
      src="/assets/icon/tlc-logo-icon.png"
      alt="TLC logo"
      sx={{ width: '100%', height: '100%', objectFit: 'contain' }}
    />
  )

  if (variant === 'compact' || variant === 'topbar' || variant === 'login') {
    return (
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
        <Box
          sx={{
            width: isLogin ? 48 : 40,
            height: isLogin ? 48 : 40,
            borderRadius: '50%',
            bgcolor: onDark ? 'rgba(255, 255, 255, 0.12)' : isLogin ? 'rgba(18, 56, 47, 0.07)' : 'rgba(198, 162, 74, 0.13)',
            border: isLogin ? '1px solid rgba(198,162,74,0.3)' : undefined,
            p: 0.4,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          {logoIcon}
        </Box>
        {showText && (
          <Box>
            <Typography
              variant="h6"
              sx={{
                fontWeight: 700,
                color: onDark ? '#ffffff' : 'primary.dark',
                lineHeight: 1.1,
                fontSize: isLogin ? '1.08rem' : '1.05rem',
                letterSpacing: isLogin ? '-0.02em' : 0,
              }}
            >
              {title}
            </Typography>
            <Typography
              variant="caption"
              sx={{
                color: onDark ? 'rgba(255,255,255,0.85)' : isLogin ? 'secondary.dark' : 'text.secondary',
                fontWeight: 800,
                letterSpacing: 1.2,
                fontSize: '0.62rem',
                textTransform: 'uppercase',
                // Mobile: ẩn subtitle "Tuan Loc Commodities" trong topbar để header
                // chỉ show "ERP CTRM" gọn. Login + compact giữ nguyên.
                display: variant === 'topbar' ? { xs: 'none', sm: 'block' } : 'block',
              }}
            >
              {subtitle}
            </Typography>
          </Box>
        )}
      </Box>
    )
  }

  if (variant === 'header') {
    return (
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
        <Box
          sx={{
            width: 36,
            height: 36,
            borderRadius: '50%',
            bgcolor: 'rgba(30, 74, 61, 0.06)',
            p: 0.35,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          {logoIcon}
        </Box>
        {showText && (
          <Box>
            <Typography variant="h6" sx={{ fontWeight: 800, lineHeight: 1.2, color: 'primary.main' }}>
              ERP CTRM
            </Typography>
            <Typography variant="caption" sx={{ color: 'text.secondary', fontSize: '0.7rem', fontWeight: 700, letterSpacing: 0.8, textTransform: 'uppercase' }}>
              Tuan Loc Commodities
            </Typography>
          </Box>
        )}
      </Box>
    )
  }

  // Sidebar variant (default)
  return (
    <Box
      sx={{
        p: 2,
        bgcolor: 'transparent',
        color: 'primary.dark',
        display: 'flex',
        alignItems: 'center',
        gap: 1.5,
      }}
    >
      <Box
        sx={{
          width: 40,
          height: 40,
          borderRadius: 2,
          bgcolor: 'rgba(198, 162, 74, 0.14)',
          p: 0.4,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexShrink: 0,
        }}
      >
        {logoIcon}
      </Box>
      {showText && (
        <Box sx={{ minWidth: 0, flex: 1 }}>
          <Typography
            variant="subtitle1"
            sx={{
              fontWeight: 800,
              color: 'primary.dark',
              lineHeight: 1.2,
              fontSize: '0.95rem',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            }}
          >
            ERP CTRM
          </Typography>
          <Typography
            variant="caption"
            sx={{
              color: 'text.secondary',
              fontWeight: 800,
              letterSpacing: 1.1,
              fontSize: '0.65rem',
              textTransform: 'uppercase',
            }}
          >
            Tuan Loc Commodities
          </Typography>
        </Box>
      )}
    </Box>
  )
}
